// Module
var code = `{{#.focused}} focused="" {{/}}
{{^.enabled}} disabled="" {{/}}
{{#.readonly}} readonly="" {{/}}    `;
// Exports
export default code;